import React from 'react';
import { connect } from 'react-redux';
import ManifestSummary from './ManifestSummary';
import cookies from 'utils/cookies';
import { dateTolocale } from 'utils/converter';
import { DateTimeFormat } from 'custom/constants';
import { discrepancySummary, ffmSummery } from 'utils/flight';
// import moment from "moment";

class ManifestSummaryContainer extends React.Component {
  constructor(props) {
    super(props);
    this.stn = cookies.get('station_code');
    this.state = {
      product: 'ALL',
      productsList: [],
      manifestSummary: {
        loose: {
          awbs: 0,
          pcs: 0,
          wgt: 0,
        },
        intact: {
          awbs: 0,
          pcs: 0,
          wgt: 0,
        },
        total: {
          awbs: 0,
          pcs: 0,
          wgt: 0,
        },
        looseulds: {
          LD3: 0,
          LD7: 0,
          MD: 0,
        },
        intactulds: {
          LD3: 0,
          LD7: 0,
          MD: 0,
        },
        totalulds: {
          LD3: 0,
          LD7: 0,
          MD: 0,
        },
      },
      showManifest: false,
      summeryType: 'Manifest Summary',
    };
  }

  componentDidMount() {
    //get page URL, get last \ and console it
    let url = window.location.href;
    let lasturl = url.substring(url.lastIndexOf('/') + 1);
    if (lasturl.includes('?')) {
      lasturl = lasturl.substring(0, lasturl.indexOf('?'));
    }
    if (lasturl) {
      if (lasturl === 'manifest') {
        this.setState({ summeryType: 'Manifest Summary' });
      } else if (lasturl === 'discrepancies') {
        this.setState({ summeryType: 'Discrepancies Summary' });
      } else if (lasturl === 'flt_report') {
        this.setState({ summeryType: 'Final Summary' });
      } else {
        this.setState({ summeryType: 'Manifest Summary' });
      }
    } else {
      this.setState({ summeryType: 'Manifest Summary' });
    }
    // console.log('^^^^^^^^^^^^^^^getting called from here 1');
    if(lasturl !== 'discrepancies' && lasturl !== 'flt_report') {
      this.processSummary();
      this.get_products();
    }
    if (this.props.showReportModal) {
      this.setState({ showManifest: true });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.discrepancyList !== this.props.discrepancyList) {
      this.processDiscrepancySummary();
      this.get_products();
    } else if (prevProps.flightreportData !== this.props.flightreportData || prevProps.exclude_disc !== this.props.exclude_disc) {
      this.processFlightReportSummary();
      this.get_products();
    } else if (prevProps.ffm !== this.props.ffm) {
      this.processSummary();
      this.get_products();
    }
    // console if manifestSummary state changed
    if (prevState.manifestSummary !== this.state.manifestSummary)
      console.log('manifestSummary state changed**************************', this.state.manifestSummary);
  }

  get_products = () => {
    let productList = [];
    this.props.ffm?.flight_uld?.map((item) => {
      item?.flight_awbs?.map((awb) => {
        if (awb.products && awb.products.length > 0) {
          awb.products.map((product) => {
            if (product.name && !productList.includes(product.name)) {
              productList.push(product.name);
            }
          });
        }
      });
    });
    this.setState({ productsList: productList });
  };

  handleProductChange = (event) => {
    this.setState({ product: event.target.value }, () => {
      // this.props.handleFilter && this.props.handleFilter(this.state.product);
      this.processSummary();
    });
  };

  processSummary = () => {
    console.log('Processing Manifest Summary__________________', this.props.ffm);
    const ffmNoteElement = document.getElementById('ffm-note');
    if (!ffmNoteElement) {
      console.error('Element with ID "ffm-note" not found.');
      // return;
    }
    if (ffmNoteElement) {
      if (this.props.ffm) {
        if (this.props.ffm?.org == this.stn) {
          if (this.props.ffm.out_ffm) {
            if (this.props.ffm.out_ffm?.processing)
              ffmNoteElement.innerHTML = 'Processing ..';
            else
              ffmNoteElement.innerHTML = `Uploaded on ${dateTolocale(this.props.ffm.out_ffm.uploaded_date, DateTimeFormat).toUpperCase()}`;
          } else {
            ffmNoteElement.innerHTML = '';
          }
        } else if (this.props.ffm?.dest == this.stn) {
          if (this.props.ffm.in_ffm) {
            if (this.props.ffm.in_ffm?.processing)
              ffmNoteElement.innerHTML = 'Processing ..';
            else
              ffmNoteElement.innerHTML = `Uploaded on ${dateTolocale(this.props.ffm.in_ffm.uploaded_date, DateTimeFormat).toUpperCase()}`;
          } else {
            ffmNoteElement.innerHTML = '';
          }
        } else {
          ffmNoteElement.innerHTML = '';
        }
      } else {
        ffmNoteElement.innerHTML = '';
      }
    }
    const {
      loose,
      intact,
      total,
      looseulds,
      intactulds,
      totalulds,

    } = ffmSummery(this.state.product, this.props.ffm);
    // console.log('setting state manifestSummary &&&&&&&&&&&&&&&&&&&&&&& 1');
    this.setState({
      manifestSummary: {
        loose,
        intact,
        total,
        looseulds,
        intactulds,
        totalulds,
      },
    });
  };

  processDiscrepancySummary = () => {

    const {
      loose,
      intact,
      total,
      looseulds,
      intactulds,
      totalulds,

    } = discrepancySummary(this.state.product, this.props.discrepancyList);

    // console.log('setting state manifestSummary &&&&&&&&&&&&&&&&&&&&&&& 2');
    this.setState({
      manifestSummary: {
        loose,
        intact,
        total,
        looseulds,
        intactulds,
        totalulds,
      },
      // summeryType: 'Discrepancy Summary',
    });
  };

  processFlightReportSummary = async () => {
    let manifestData = [];
    let dlist = [];
    if (this.props.discrepancyList && this.props.discrepancyList.length > 0) {
      dlist = this.props.discrepancyList.map(discrepancy => ({
        id: discrepancy.id,
        uld_no: discrepancy.uld_no,
        is_bulk: discrepancy.is_bulk,
        org: discrepancy.org,
        dest: discrepancy.dest,
        type: discrepancy.handled_as,
        uld_type: discrepancy.uld_type,
        segment: discrepancy.segment,
        remark: discrepancy.remark,
        flightId: discrepancy.flightId,
        companyId: discrepancy.companyId,
        stationId: discrepancy.stationId,
        is_discrepancy: true,
        disc_type: discrepancy.type,
        flight_awbs: [
          {
            id: discrepancy.id,
            awb_no: discrepancy.awb_no,
            org: discrepancy.org,
            dest: discrepancy.dest,
            pcs: discrepancy.t_pcs,
            wgt: discrepancy.t_wgt,
            d_pcs: discrepancy.d_pcs,
            d_wgt: discrepancy.d_wgt,
            wgt_unit: 'K',
            spl_code: null,
            awb_conflict: null,
            prod_conflict: null,
            remark: discrepancy.remark,
            awbId: null,
            flightId: discrepancy.flightId,
            companyId: discrepancy.companyId,
            stationId: discrepancy.stationId,
            flight_uldId: discrepancy.id,
            import_awbId: null,
            products: discrepancy.products || [],
            is_discrepancy: true,
          }
        ]
      }));
    }

    if (this.props.exclude_disc) {
      manifestData = Array.isArray(this.props.ffm?.flight_uld) ? this.props.ffm.flight_uld : [];
    } else {
      const flightUld = Array.isArray(this.props.ffm?.flight_uld) ? this.props.ffm.flight_uld : [];
      const discrepancyList = Array.isArray(dlist) ? dlist : [];
      manifestData = [
        ...flightUld,
        ...discrepancyList
      ];
    }
    let excludeDiscrepancies = this.props.exclude_disc;
    let uld_numbers = [];
    let loose = {
      awbs: 0,
      pcs: 0,
      wgt: 0,
    };
    let intact = {
      awbs: 0,
      pcs: 0,
      wgt: 0,
    };
    let total = {
      awbs: 0,
      pcs: 0,
      wgt: 0,
    };
    let looseulds = {
      LD3: 0,
      LD7: 0,
      MD: 0,
    };
    let intactulds = {
      LD3: 0,
      LD7: 0,
      MD: 0,
    };
    let totalulds = {
      LD3: 0,
      LD7: 0,
      MD: 0,
    };
    let totalAwbLoose = [];
    let totalAwbIntact = [];
    let totalAwbNo = [];
    manifestData?.forEach((item) => {
      let searchString = ['LD3', 'LD7', 'MD'];
      let uldtype = searchString.find(val => item.uld_type?.includes(val));
      let inc = 1;
      if (excludeDiscrepancies && !item.is_discrepancy || (!excludeDiscrepancies && !item.is_discrepancy)) {
        if (item.uld_type?.includes('2X')) {
          inc = 2;
        }
        if (item.type === 'Loose' && uldtype) {
          looseulds[uldtype] += inc;
        }
        if (item.type === 'Intact' && uldtype) {
          intactulds[uldtype] += inc;
        }
        if (uldtype) {
          totalulds[uldtype] += inc;
        }
      } else if (!excludeDiscrepancies && (item.disc_type === 'Found Cargo' || item.disc_type === 'Over Carried')) {
        if (!uld_numbers.includes(item.uld_no)) {
          if (item.uld_type?.includes('2X')) {
            inc = 2;
          }
          if (item.type === 'Loose' && uldtype) {
            looseulds[uldtype] += inc;
          }
          if (item.type === 'Intact' && uldtype) {
            intactulds[uldtype] += inc;
          }
          if (uldtype) {
            totalulds[uldtype] += inc;
          }
        }
      } else if (!excludeDiscrepancies && (item.disc_type === 'Missing Cargo' || item.disc_type === 'Short Shipped')) {
        if (uld_numbers.includes(item.uld_no)) {
          // find matching uld_no and map flight_awbs and check sum of pcs, wge, d_pcs, d_wgt for all awbs in uld
          let matchingUld = manifestData.find(uld => uld.uld_no === item.uld_no && !uld.is_discrepancy);
          if (matchingUld) {
            let pcsSum = 0;
            let wgtSum = 0;
            let dPcsSum = 0;
            let dWgtSum = 0;
            matchingUld.flight_awbs.forEach((awb) => {
              pcsSum += parseInt(awb.pcs || 0);
              wgtSum += parseFloat(awb.wgt || 0);
            });
            item.flight_awbs.forEach((awb) => {
              dPcsSum += parseInt(awb.d_pcs || 0);
              dWgtSum += parseFloat(awb.d_wgt || 0);
            });
            // console.log('pcsSum:', pcsSum, 'dPcsSum:', dPcsSum);
            // console.log('wgtSum:', wgtSum, 'dWgtSum:', dWgtSum);
            if(pcsSum === dPcsSum && wgtSum === dWgtSum) {
              //subtract uld count for intact and total
              let inc = -1;
              if (item.uld_type?.includes('2X')) {
                inc = -2;
              }
              if (item.type === 'Loose' && uldtype) {
                looseulds[uldtype] += inc;
              }
              if (item.type === 'Intact' && uldtype) {
                intactulds[uldtype] += inc;
              }
              if (uldtype) {
                totalulds[uldtype] += inc;
              }
            }
          }
        }
      }
      item?.flight_awbs?.forEach((awb) => {
        if ((excludeDiscrepancies && !awb.is_discrepancy) || (!excludeDiscrepancies && !awb.is_discrepancy)) {
          if (this.state.product === 'ALL' || (awb.product && awb.product.name === this.state.product)) {
            if (item.type === 'Loose') {
              if (totalAwbLoose && !totalAwbLoose.includes(awb.awb_no)) {
                totalAwbLoose.push(awb.awb_no);
              }
              loose.awbs = totalAwbLoose.length;
              if (!awb.is_discrepancy) {
                loose.pcs += parseInt(awb.pcs || 0);
                loose.wgt += parseFloat(awb.wgt || 0);
              } else if (awb.is_discrepancy) {
                loose.pcs += parseInt(awb.d_pcs || 0);
                loose.wgt += parseFloat(awb.d_wgt || 0);
              }
            }
            if (item.type === 'Intact') {
              if (totalAwbIntact && !totalAwbIntact.includes(awb.awb_no)) {
                totalAwbIntact.push(awb.awb_no);
              }
              intact.awbs = totalAwbIntact.length;
              if (!awb.is_discrepancy) {
                intact.pcs += parseInt(awb.pcs || 0);
                intact.wgt += parseFloat(awb.wgt || 0);
              } else if (awb.is_discrepancy) {
                intact.pcs += parseInt(awb.d_pcs || 0);
                intact.wgt += parseFloat(awb.d_wgt || 0);
              }
            }
            if (totalAwbNo && !totalAwbNo.includes(awb.awb_no)) {
              totalAwbNo.push(awb.awb_no);
            }
            total.awbs = totalAwbNo.length;
            if (!awb.is_discrepancy) {
              total.pcs += parseInt(awb.pcs || 0);
              total.wgt += parseFloat(awb.wgt || 0);
            } else if (awb.is_discrepancy) {
              total.pcs += parseInt(awb.d_pcs || 0);
              total.wgt += parseFloat(awb.d_wgt || 0);
            }
          }
        } else if (!excludeDiscrepancies && awb.is_discrepancy && (item.disc_type === 'Found Cargo' || item.disc_type === 'Over Carried' || item.disc_type === 'Missing Cargo' || item.disc_type === 'Short Shipped')) {
          if (this.state.product === 'ALL' || (awb.product && awb.product.name === this.state.product)) {
            // Determine operation based on disc_type
            let operation = item.disc_type === 'Missing Cargo' || item.disc_type === 'Short Shipped'
              ? 'subtract'
              : 'add';
            // if 'Missing Cargo' or 'Short Shipped'. // get list of uld_index and awb_index from manifestData where !is_discrepancy and get list of uld_index and awb_index from manifest Data where is_discrepancy. by awb_no
            if (operation === 'subtract') {
              let manifestAWBs = [];
              let disc_AWBs = [];
              // move all records where is_discrepancy to the bottom of the manifestAWBs array.
              let newmanifestData = manifestData.filter(item => !item.is_discrepancy);
              newmanifestData = newmanifestData.concat(manifestData.filter(item => item.is_discrepancy));
              newmanifestData.forEach((uld, uindex) => {
                if (uld.flight_awbs && uld.flight_awbs.length > 0) {
                  uld.flight_awbs.forEach((awbItem, aindex) => {
                    let obj = {};
                    if (awbItem.awb_no === awb.awb_no) {
                      obj = {
                        uld_no: uld.uld_no,
                        awb_no: awbItem.awb_no,
                        pcs: awbItem.is_discrepancy ? parseInt(awbItem.d_pcs || 0) : parseInt(awbItem.pcs || 0),
                        wgt: awbItem.is_discrepancy ? parseFloat(awbItem.d_wgt || 0) : parseFloat(awbItem.wgt || 0),
                        uld_index: uindex,
                        awb_index: aindex,
                        type: uld.type,
                        uld_is_descripancy: uld.is_discrepancy || false,
                        is_discrepancy: awbItem.is_discrepancy || false,
                      };

                      if (!awbItem.is_discrepancy) {
                        manifestAWBs.push(obj);
                      } else if (awbItem.is_discrepancy && (item.disc_type === 'Missing Cargo' || item.disc_type === 'Short Shipped')) {
                        disc_AWBs.push(obj);
                      }
                    }
                  });
                }
              });
              //if disc_AWBs.length < manifestAWBs.length, Do nothing.
              // else map through disc_AWBs and check for matching uld_no and awb_no in manifestAWBs, if pcs and wgt are same, then subtract from total, loose and intact.
              // console.log('discAwbs:', disc_AWBs);
              // console.log('manifestAwbs:', manifestAWBs);
              if (disc_AWBs.length >= manifestAWBs.length) {
                disc_AWBs.forEach((discAwb) => {
                  let match = manifestAWBs.find(manifestAwb =>
                    manifestAwb.uld_no === discAwb.uld_no &&
                    manifestAwb.awb_no === discAwb.awb_no &&
                    manifestAwb.pcs === discAwb.pcs &&
                    manifestAwb.wgt === discAwb.wgt
                  );
                  if (match) {
                    console.log('Match found:', match);
                    console.log('discAwb:', discAwb);
                    if (match.type === 'Loose') {
                      //remove awb_no from totalAwbLoose
                      if (totalAwbLoose && totalAwbLoose.includes(match.awb_no)) {
                        totalAwbLoose = totalAwbLoose.filter(awbNo => awbNo !== match.awb_no);
                      }
                      loose.awbs = totalAwbLoose.length;
                    }
                    if (match.type === 'Intact') {
                      //remove awb_no from totalAwbIntact
                      if (totalAwbIntact && totalAwbIntact.includes(match.awb_no)) {
                        // console.log('Removing awb_no from totalAwbIntact:', match.awb_no);
                        // console.log('Before:', totalAwbIntact);
                        totalAwbIntact = totalAwbIntact.filter(awbNo => awbNo !== match.awb_no);
                        // console.log('After:', totalAwbIntact);
                      }
                      intact.awbs = totalAwbIntact.length;
                    }
                  }
                });
              }
            } else {
              if (item.type === 'Loose') {
                if (totalAwbLoose && !totalAwbLoose.includes(awb.awb_no)) {
                  totalAwbLoose.push(awb.awb_no);
                }
                loose.awbs = totalAwbLoose.length;
              } else if (item.type === 'Intact') {
                if (totalAwbIntact && !totalAwbIntact.includes(awb.awb_no)) {
                  totalAwbIntact.push(awb.awb_no);
                }
                intact.awbs = totalAwbIntact.length;
              }
            }
            if (item.type === 'Loose') {
              let pcs = !awb.is_discrepancy ? parseInt(awb.pcs || 0) : parseInt(awb.d_pcs || 0);
              let wgt = !awb.is_discrepancy ? parseFloat(awb.wgt || 0) : parseFloat(awb.d_wgt || 0);
              loose.pcs += operation === 'add' ? pcs : -pcs;
              loose.wgt += operation === 'add' ? wgt : -wgt;
            }
            if (item.type === 'Intact') {
              let pcs = !awb.is_discrepancy ? parseInt(awb.pcs || 0) : parseInt(awb.d_pcs || 0);
              let wgt = !awb.is_discrepancy ? parseFloat(awb.wgt || 0) : parseFloat(awb.d_wgt || 0);
              intact.pcs += operation === 'add' ? pcs : -pcs;
              intact.wgt += operation === 'add' ? wgt : -wgt;
            }
            // if (totalAwbNo && !totalAwbNo.includes(awb.awb_no)) {
            //   totalAwbNo.push(awb.awb_no);
            // }
            //totalAwbNo should be combination of totalAwbLoose and totalAwbIntact
            totalAwbNo = [...new Set([...totalAwbLoose, ...totalAwbIntact])];
            total.awbs = totalAwbNo.length;
            let pcs = !awb.is_discrepancy ? parseInt(awb.pcs || 0) : parseInt(awb.d_pcs || 0);
            let wgt = !awb.is_discrepancy ? parseFloat(awb.wgt || 0) : parseFloat(awb.d_wgt || 0);
            total.pcs += operation === 'add' ? pcs : -pcs;
            total.wgt += operation === 'add' ? wgt : -wgt;
          }
        }
      });
      if (!uld_numbers.includes(item.uld_no)) {
        uld_numbers.push(item.uld_no);
      }
    });
    // console.log('setting state manifestSummary &&&&&&&&&&&&&&&&&&&&&&& 3');
    this.setState({
      manifestSummary: {
        loose,
        intact,
        total,
        looseulds,
        intactulds,
        totalulds,
      },
      // summeryType: 'Flight Report Summary',
    }, () => {
      console.log('Final manifestSummary state: 3', this.state.manifestSummary);
      if (this.props.printFunction) {
        this.props.printFunction(this.state.manifestSummary, 'flightReportSummary');
      }
    });
  };

  changeCheck = (e) => {
    this.setState({ showManifest: e.target.checked });
  };

  render() {
    return (
      <>
        <ManifestSummary
          manifestSummary={this.state.manifestSummary}
          productsList={this.state.productsList}
          product={this.state.product}
          handleProductChange={this.handleProductChange}
          showManifest={this.state.showManifest}
          changeCheck={this.changeCheck}
          showReportModal={this.props.showReportModal}
          nil={this.props.nil}
          summeryType={this.state.summeryType}
        />
      </>
    );
  }

}

const mapStateToProps = (state) => {
  return { ffm: state.ffm };
};

export default connect(mapStateToProps)(ManifestSummaryContainer);